const addValueToString = (value, position, addValue) => {
  if (!value) {
    return ''
  } else {
    const array = value.split('')

    if (position > array.length - 1) {
      return value
    } else {
      array.splice(position, 0, addValue)
      return array.join('')
    }
  }
}

const testNumber = (mini, i, value) => {
  mini.mini--

  if ((i + mini.mini) <= value.length - 1) {
    while (mini.mini >= 0) {
      const letter = value[i + mini.mini]
      const unicode = letter.charCodeAt(0)
      if (unicode < 48 || unicode > 57) break
      mini.mini--
    }
  }
}

const code128 = (value) => {
  if (!value) return ''

  const mini = { mini: 0 }
  let checkSum, dummy
  let tableB = true
  let encoded = ''
  let i = 0

  if (value.length >= 0) {
    for (i = 0; i <= value.length - 1; i++) {
      const unicode = value[i].charCodeAt(0)

      if (unicode < 32 || unicode > 126) return ''
    }
  }

  i = 0
  while (i < value.length) {
    if (tableB) {
      mini.mini = (i === 0 || i + 3 === value.length - 1) ? 4 : 6

      testNumber(mini, i, value)

      if (mini.mini < 0) {
        if (i === 0) {
          encoded = String.fromCharCode(210)
        } else {
          encoded = `${encoded}${String.fromCharCode(204)}`
        }

        tableB = false
      } else {
        if (i === 0) encoded = String.fromCharCode(209)
      }
    }

    if (!tableB) {
      mini.mini = 2

      testNumber(mini, i, value)

      if (mini.mini < 0) {
        dummy = parseInt(value.substr(i, 2).replace(/^\D+/g, ''))
        dummy = dummy < 95 ? dummy + 32 : dummy + 105
        encoded = `${encoded}${String.fromCharCode(dummy)}`
        i += 2
      } else {
        encoded = `${encoded}${String.fromCharCode(205)}`
        tableB = true
      }
    }

    if (tableB) {
      encoded = `${encoded}${value[i]}`
      i++
    }
  }

  for (i = 0; i < encoded.length; i++) {
    const unicode = encoded[i].charCodeAt(0)
    dummy = unicode < 127 ? unicode - 32 : unicode - 105
    if (i === 0) checkSum = dummy
    checkSum = (checkSum + (i * dummy)) % 103
  }

  checkSum = checkSum < 95 ? checkSum + 32 : checkSum + 105

  encoded = `${encoded}${String.fromCharCode(checkSum)}${String.fromCharCode(211)}`

  return encoded
}

export default {
  capitalize (value) {
    if (!value) return ''

    const array = value.split(' ')

    for (let i = 0; i < array.length; i++) {
      const element = array[i]

      array[i] = element.charAt(0).toUpperCase() + element.slice(1)
    }

    return array.join(' ')
  },

  phoneNumber (value) {
    return addValueToString(addValueToString(value, 6, ' - '), 3, ' - ')
  },

  date (date) {
    if (!date) return
    if (!date.getDate) date = new Date(date)
    const dateString = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
    const monthString = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
    return `${dateString}/${monthString}/${date.getFullYear()}`
  },

  time (dateString) {
    if (!dateString) return
    const date = new Date(dateString)
    let hours = date.getHours()
    const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
    const amPm = hours < 12 ? 'am' : 'pm'
    hours = hours % 12 || 12
    return `${hours}:${minutes} ${amPm}`
  },

  dateTime (dateString, seconds = false, justDate = false) {
    if (!dateString) return
    const date = new Date(dateString)
    if (justDate) return this.date(date)
    return `${this.date(date)} ${this.time(date, seconds)}`
  },

  dateName (dateString) {
    const today = new Date()

    const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
    if (!dateString) return
    const date = new Date(dateString)

    const isToday = today.getDate() === date.getDate() &&
                    today.getMonth() === date.getMonth() &&
                    today.getFullYear() === date.getFullYear()

    if (isToday) return 'Hoy'

    const day = date.getDate()
    const month = months[date.getMonth()]
    const year = today.getFullYear() === date.getFullYear() ? '' : date.getFullYear()
    const yearTwoDigits = year.toString().slice(-2)

    return `${day} ${month}${yearTwoDigits ? ` ${yearTwoDigits}` : ''}`
  },

  percent (value) {
    if (!value) return value
    return `${parseInt(value)}%`
  },

  money (value, wordFree = '') {
    if (wordFree && value === 0) return wordFree
    if (value === 0) return '$ 0'
    if (!value) return value

    try {
      return `$ ${new Intl.NumberFormat('es-CO').format(value)}`
    } catch (error) {
      return value
    }
  },

  number (value) {
    if (!value) return value
    return new Intl.NumberFormat('es-CO').format(value)
  },

  arrayToString (array) {
    if (!array.length) return '-'
    return array.join(', ')
  },

  replaceString (value, search, replace) {
    if (typeof value !== 'string') return value
    return value.split(search).join(replace)
  },

  getLastString (value, search) {
    if (typeof value !== 'string') return value
    const array = value.split(search)
    return array[array.length - 1]
  },

  code128,

  personSpanish (value) {
    const personSpanish = {man: 'hombre', woman: 'mujer'}
    return personSpanish[value]
  }
}



// WEBPACK FOOTER //
// ./src/config/filters.js